import { render, staticRenderFns } from "./VideoBlobControls.vue?vue&type=template&id=bec1062c&scoped=true&"
import script from "./VideoBlobControls.vue?vue&type=script&lang=js&"
export * from "./VideoBlobControls.vue?vue&type=script&lang=js&"
import style0 from "./VideoBlobControls.vue?vue&type=style&index=0&id=bec1062c&scoped=true&lang=css&"
import style1 from "./VideoBlobControls.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec1062c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSlider,VSpacer})
